<template>
  <div class="logo">
    <!-- <router-link :to="{ name: 'dashboard' }"> -->
    <!-- <LogoSvg alt="logo" /> -->
    <img src="~@/assets/logo.png" style="width: 60px; margin-right: 15px" class="logo" alt="logo" />
    <h1 v-if="showTitle">{{ title }}</h1>
    <!-- </router-link> -->
  </div>
</template>

<script>
// import LogoSvg from '@/assets/logo.svg?inline'

export default {
  name: 'Logo',
  components: {
    // LogoSvg
  },
  props: {
    title: {
      type: String,
      default: '乐私塾',
      required: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
}
</script>
